import React from 'react';
import {GenericReportingDropdowns} from '../../../containers/GenericReportingDropdowns';
import LtrTabDropdowns from "./LtrTabDropdowns";
import CohortTabDropdowns from "./CohortTabDropdowns";

export const CustomerPerformancePageDropdowns = ({ tabKey }) => {
  const includeGranularity = tabKey === "1";

  function GetExtraDropdownsForTabs(tabKey) {
    switch (tabKey) {
      case "1":
        return null;
      case "2":
        return <LtrTabDropdowns />;
      case "3":
        return <CohortTabDropdowns />;
      case "4":
        return null;
      default:
        return null;
    }
  }

  return (
      <GenericReportingDropdowns
        includeDateRange={includeGranularity}
        includeGranularity={includeGranularity}
        includeSingleSelectRegion={!includeGranularity}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={false}
        extraDropdowns={GetExtraDropdownsForTabs(tabKey)}
      />
  );
};
export default CustomerPerformancePageDropdowns;